import React from 'react';
import { Fab } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import EditReferee from './EditReferee';
import EntityCard from '../components/EntityCard';
import EntityCardHeader from '../components/EntityCardHeader';
import EntityCardContent from '../components/EntityCardContent';
import EntityCardTab from '../components/EntityCardTab';
import EntityCardFooter from '../components/EntityCardFooter';
import ProviderPopover from '../../../components/ProviderPopover';
import Mapping from '../components/Mapping';
import { getSuggestionPrimaryText } from '../../tasks/helper';

const RefereeCard = ({
  referee,
  attributeTypes,
  currentEdits,
  buttonEnable,
  providers,
  readOnly,
  overwriteAndReloadEntity,
  fetchEntityAndOverwrites,
}) => {
  const overwriteEntity = () => {
    overwriteAndReloadEntity(referee.id, currentEdits);
  };

  const reloadContent = () => {
    fetchEntityAndOverwrites(referee.id);
  };

  return (
    referee && (
      <EntityCard>
        <EntityCardHeader
          primary={getSuggestionPrimaryText('referee', referee)}
          imgUrl=""
        >
          {readOnly && <ProviderPopover entityType="referee" providers={providers} />}
        </EntityCardHeader>
        <EntityCardContent
          tabs={
            readOnly ? ['information'] : ['information', 'mappings']
          }
        >
          <EntityCardTab tab="information">
            <EditReferee
              entity={referee}
              entityType="referee"
              key={referee.id}
              editableProperties={readOnly ? [] : Object.keys(referee).filter(key => key !== 'id')}
              attributeTypes={attributeTypes}
              reloadContent={reloadContent}
            />

            {!readOnly && (
              <EntityCardFooter>
                <Fab
                  style={{ minWidth: 56 }}
                  disabled={!buttonEnable}
                  color="primary"
                  aria-label="Save"
                  onClick={overwriteEntity}
                >
                  <SaveIcon />
                </Fab>
              </EntityCardFooter>
            )}
          </EntityCardTab>
          <EntityCardTab tab="mappings">
            <Mapping entityType="referee" entityId={referee.id} />
          </EntityCardTab>
        </EntityCardContent>
      </EntityCard>
    )
  );
};

export default RefereeCard;
